<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 17.142 14.999"
  >
    <path
      id="Icon_awesome-wallet"
      data-name="Icon awesome-wallet"
      d="M15.441,5.464H2.678a.536.536,0,0,1,0-1.071H15.535a.536.536,0,0,0,.536-.536A1.607,1.607,0,0,0,14.464,2.25H2.143A2.143,2.143,0,0,0,0,4.393V15.107a2.143,2.143,0,0,0,2.143,2.143h13.3a1.658,1.658,0,0,0,1.7-1.607V7.071A1.658,1.658,0,0,0,15.441,5.464Zm-1.513,6.964A1.071,1.071,0,1,1,15,11.357,1.072,1.072,0,0,1,13.928,12.428Z"
      transform="translate(0 -2.25)"
      fill="#f0324c"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-10'
    },
    height: {
      type: String,
      default: 'h-10'
    }
  }
}
</script>
